import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ProgressNavigationItem} from '@wba/models/progress-navigation-item';
import {BaProgressNav} from '@design/bapf-pattern-library';
import {ProgressNavigationService} from "@wba/services/commons/progress-navigation.service";
import {Observable, startWith} from "rxjs";
import {map} from "rxjs/operators";
import {ProgressNavigationListV2} from "@wba/models/progress-navigation-list";

@Component({
    selector: 'wba-progress-navigation',
    templateUrl: './progress-navigation.component.html',
    styleUrls: ['./progress-navigation.component.scss'],
    standalone: false
})
export class ProgressNavigationComponent implements OnInit {

  @Output() clickEvent: EventEmitter<ProgressNavigationItem> = new EventEmitter();

  instanceOfBaProgressNav!: BaProgressNav;

  $items: Observable<ProgressNavigationItem[]>

  constructor(service: ProgressNavigationService) {

    this.$items = service.changeValues.pipe(
      /*
        Navigation items don't show up without this initial value.
        Not sure why. First value should be from ProgressNavigationService.restore
       */
      startWith(ProgressNavigationListV2),
      map(items => {
          let activePassed = false;
          return items.map( item => {
            item.disabled = activePassed;
            item.progressed = !activePassed;
            activePassed = activePassed || item.active;
            return item;
          })
      })
    )
  }

  @ViewChild('navigation', {static: true}) navigation: ElementRef;

  ngOnInit() {
    this.instanceOfBaProgressNav = new BaProgressNav(this.navigation.nativeElement);
  }
}
